<app-user-search class="pb-4" [texts]="DEFAULT_USER_SEARCH_TEXT_CONFIG" (select)="onUserSelect($event)" />

<div class="p-6 pt-4 max-w-[760px]">
    <h2 class="m-0 text-xl text-[var(--color-text-strong)]">
        {{ 'user-management.dialogs.add-dialog.title' | translate }}
    </h2>
    <div class="py-3">
        <form [formGroup]="addUserForm" class="mt-4 flex flex-col gap-2">
            <div class="flex gap-4 pb-[5px]">
                <div class="flex w-48 flex-col gap-2">
                    <sh-input-text mandatory label="GID" formControlName="gid" />
                </div>
                <div class="flex w-56 flex-col gap-2">
                    <sh-input-text
                        mandatory
                        [label]="'user-management.dialogs.add-dialog.first-name' | translate"
                        formControlName="firstName"
                    />
                </div>
                <div class="flex w-56 flex-col gap-2">
                    <sh-input-text
                        mandatory
                        [label]="'user-management.dialogs.add-dialog.last-name' | translate"
                        formControlName="lastName"
                    />
                </div>
            </div>
            <div class="flex gap-4">
                <div class="flex w-48 flex-col gap-2">
                    <sh-input-text
                        mandatory
                        [label]="'user-management.dialogs.add-dialog.email' | translate"
                        formControlName="email"
                    />
                </div>
                <div class="flex w-56 flex-col">
                    <sh-select
                        formControlName="roles"
                        [label]="'user-management.dialogs.edit-dialog.roles' | translate"
                        [options]="roleOptions"
                        [multiSelect]="true"
                    />
                </div>
            </div>
        </form>
    </div>
    <div class="flex justify-end items-center gap-2 mt-8">
        <sh-button
            slot="footer"
            color="secondary"
            icon="arrow-line-left-s"
            iconPosition="left"
            size="max-content"
            [label]="'user-management.dialogs.add-dialog.cancel' | translate"
            [ariaLabel]="'user-management.dialogs.add-dialog.cancel' | translate"
            (clicked)="cancel()"
        />
        <sh-button
            slot="footer"
            color="primary"
            icon="edit"
            iconPosition="left"
            size="max-content"
            [disabled]="!addUserForm.valid"
            [label]="'user-management.dialogs.add-dialog.confirm' | translate"
            [ariaLabel]="'user-management.dialogs.add-dialog.confirm' | translate"
            (clicked)="createUser()"
        />
    </div>
</div>
